import { CheckCircle2, Clock, MapPin, Sparkles } from "lucide-react";
import { Reveal, SectionHead } from "./shared";
import { scrollToId } from "@/lib/lenis";

const UPCOMING = [
  {
    id: "ameno",
    day: "15",
    month: "novembre",
    title: "Incontro con l'autrice ad Ameno",
    kind: "Incontra l'autrice",
    place: "Ameno (NO)",
    note: "Insieme all'associazione Un Filo per Natale.",
  },
  {
    id: "pettenasco",
    day: "21",
    month: "novembre",
    title: "Presentazione in Biblioteca a Pettenasco",
    kind: "Presentazione",
    place: "Biblioteca di Pettenasco (NO)",
    time: "Ore 16:30",
    note: "Presentazione del romanzo con l'autrice.",
  },
  {
    id: "plusport",
    day: "29",
    month: "novembre",
    title: "Festa di Natale alla struttura +Sport",
    kind: "Incontra l'autrice",
    place: "San Maurizio d'Opaglio (NO)",
    note: "Il libro sarà presente alla festa: l'occasione giusta per una copia firmata sotto l'albero.",
  },
];

const TOWNS = ["Orta San Giulio", "Omegna", "Pettenasco", "Gozzano", "Miasino", "Ameno", "San Maurizio d'Opaglio"];

const EventCard = ({ ev, delay }) => (
  <Reveal delay={delay}>
    <div
      className="card-parchment flex h-full flex-col overflow-hidden rounded-xl sm:flex-row"
      data-testid={`event-upcoming-${ev.id}`}
    >
      <div className="flex shrink-0 items-center justify-center gap-2 bg-lake-deep px-6 py-5 sm:w-32 sm:flex-col sm:gap-0">
        <p className="font-serif text-4xl leading-none text-gold-shimmer">{ev.day}</p>
        <p className="text-[10px] uppercase tracking-[0.25em] text-parchment-ivory sm:mt-1.5">{ev.month}</p>
      </div>
      <div className="flex-1 p-6 sm:p-7">
        <p className="text-[10px] font-semibold uppercase tracking-[0.25em] text-sunset">{ev.kind}</p>
        <h3 className="mt-1.5 font-serif text-xl text-ink-dark">{ev.title}</h3>
        <p className="mt-2 flex items-center gap-2 text-sm text-ink-muted">
          <MapPin className="h-4 w-4 shrink-0 text-gold" />
          {ev.place}
        </p>
        {ev.time && (
          <p className="mt-1.5 flex items-center gap-2 text-sm text-ink-muted">
            <Clock className="h-4 w-4 shrink-0 text-gold" />
            {ev.time}
          </p>
        )}
        <p className="mt-3 text-sm leading-relaxed text-ink-muted">{ev.note}</p>
      </div>
    </div>
  </Reveal>
);

export default function Eventi() {
  return (
    <section id="eventi" className="relative bg-lake-teal/20 py-20 lg:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHead
          kicker="Eventi & Firmacopie"
          title="I prossimi incontri"
          sub="Il romanzo è in libreria e il giro sul territorio continua: ecco dove trovare l'autrice e la tua copia firmata."
        />

        <div className="mx-auto mt-14 grid max-w-4xl grid-cols-1 gap-6">
          {UPCOMING.map((ev, i) => (
            <EventCard key={ev.id} ev={ev} delay={i * 0.12} />
          ))}
        </div>

        <Reveal delay={0.2}>
          <p
            className="mx-auto mt-8 flex max-w-4xl items-start gap-2.5 rounded-lg border border-gold/20 bg-lake-deep/40 p-4 text-sm leading-relaxed text-parchment-ivory/70"
            data-testid="event-past-note"
          >
            <CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0 text-gold-shimmer" />
            <span>
              Si è già svolta: la prima presentazione di sabato 31 ottobre al Teatro degli Scalpellini di
              San Maurizio d'Opaglio. Grazie a tutte le persone che hanno riempito la sala.
            </span>
          </p>
        </Reveal>

        <Reveal delay={0.25}>
          <div className="mt-10 rounded-xl border border-gold/25 bg-lake-deep/40 p-8" data-testid="events-tour-note">
            <div className="flex items-center gap-3">
              <div className="flex h-11 w-11 items-center justify-center rounded-full bg-gold/15">
                <Sparkles className="h-5 w-5 text-gold-shimmer" />
              </div>
              <h3 className="font-serif text-xl text-parchment-ivory">Il tour continua sulle rive del lago</h3>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-parchment-ivory/60">
              Nuove date in arrivo nei comuni del Lago d'Orta, in collaborazione con pro loco, biblioteche,
              librerie e festival letterari del Piemonte. Vuoi ospitare una presentazione nel tuo comune,
              nella tua libreria o biblioteca? Scrivici dal modulo contatti.
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {TOWNS.map((t) => (
                <span
                  key={t}
                  className="inline-flex items-center gap-1.5 rounded-full border border-gold/25 px-3 py-1 text-xs text-parchment-ivory/70"
                >
                  <MapPin className="h-3 w-3 text-gold" />
                  {t}
                </span>
              ))}
            </div>
            <button
              data-testid="events-notify-button"
              onClick={() => scrollToId("contatti")}
              className="mt-7 rounded-full bg-gold px-6 py-2.5 text-sm font-semibold text-ink-dark transition-transform duration-300 hover:-translate-y-0.5"
            >
              Proponi una presentazione
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
